var _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExcel(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 10,
    height: 13,
    transform: "translate(9 8)",
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.125 6.3335H23.9028V23.6668H18.125V6.3335Z",
    fill: "#F7FAFC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6 23.6667L22.1778 28V2L6 6.33333V23.6667ZM10.0443 9.22222H12.6155L14.0599 12.4289L15.5622 9.22222H18.0755L15.4465 13.8155L18.3354 19.2177H15.7643L14.0599 15.4043L12.3843 19.2177H9.87106L12.6733 13.9022L10.0443 9.22222Z",
    fill: "#38A169"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExcel);
export default __webpack_public_path__ + "static/media/Excel.b71fff4c81688b33349a09a32c0154da.svg";
export { ForwardRef as ReactComponent };